var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14V19H0V7.04358e-07H19.138C19.2256 -0.000146387 19.3118 0.0227469 19.3878 0.0663857C19.4638 0.110025 19.527 0.172876 19.5711 0.24864C19.6151 0.324403 19.6385 0.410418 19.6388 0.498061C19.6392 0.585705 19.6165 0.671897 19.573 0.748001L16 7L19.573 13.252C19.6165 13.3281 19.6392 13.4143 19.6388 13.5019C19.6385 13.5896 19.6151 13.6756 19.5711 13.7514C19.527 13.8271 19.4638 13.89 19.3878 13.9336C19.3118 13.9773 19.2256 14.0001 19.138 14H2ZM2 2V12H16.554L13.696 7L16.554 2H2Z",
    fill: "#1D2740"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewFlag);
export default __webpack_public_path__ + "static/media/review_flag.41c53878d43ad389b031f1d4295fc32f.svg";
export { ForwardRef as ReactComponent };